var exports = {
  "$": "inlineAnnotation__9kLG1B",
};

module.exports = exports;
